import '../../assets/global.css'
import { useUser } from '../../context/userContext';
import { getAllSalesByAgentId, getAllSalesByGroupName } from '../../api/salesApi';
import { useNavigate } from 'react-router-dom';
import GenericSalesList from '../common/genericSalesList';
import { Box } from '@mui/material';

export default function GroupSalesList() {
    const navigate = useNavigate();
    const { user } = useUser();

    const handleCreate = () => {
        navigate("/sales/create");
    };

    return (
        <div>
            <Box sx={{ mb: 2 }}>
                <h2 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 700, color: '#0F172A', fontFamily: "'Poppins', sans-serif" }}>Group Sales</h2>
                <p style={{ margin: 0, fontSize: '0.8rem', color: '#64748B', fontFamily: "'Poppins', sans-serif" }}>Sales from your group</p>
            </Box>
            <GenericSalesList
                fetchDataApi={(archived) => getAllSalesByGroupName(user?.groupName, archived)}
                onCreate={handleCreate}
            />
        </div>
    )
}